import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { pick, prop } from 'ramda';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { showVerificationCardPinPopup } from 'js/app/components/popups/VerificationCardPinPopup/actions';
import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { storageService } from 'js/services/storage.service';
import { useAuthSelector, useUserSelector } from 'js/store/hooks';

export const useVerificationCardPin = () => {
    const dispatch = useDispatch();
    const {
        isLoggedIn, allPlayerTags, previousLoginTime
    } = useUserSelector(pick(['isLoggedIn', 'allPlayerTags', 'previousLoginTime']));
    const storageData = storageService.local.getItem('pinValidationSkipped');
    const [dTagDisablePinValidation] = useDynamicTags([DYNAMIC_TAG_NAMES.disablePinValidation]);
    const isLoginInProcess = useAuthSelector(prop('isLoginInProcess'));
    const isTagCorrect = useMemo(() => allPlayerTags?.lightAuthenticationVerified?.value === 'checkPINOnline', [allPlayerTags]);

    return useEffect(() => {
        if (
            isLoggedIn &&
            !isLoginInProcess &&
            isTagCorrect &&
            dTagDisablePinValidation !== 'true' &&
            storageData !== previousLoginTime &&
            storageData !== 'done'
        ) {
            dispatch(showVerificationCardPinPopup());
        }
    }, [dispatch, isLoggedIn, isTagCorrect, storageData, dTagDisablePinValidation, previousLoginTime, isLoginInProcess]);
};
